import { render } from "./DxtAccountStatistics.vue?vue&type=template&id=0c60ca0a&scoped=true"
import script from "./DxtAccountStatistics.vue?vue&type=script&lang=js"
export * from "./DxtAccountStatistics.vue?vue&type=script&lang=js"

import "./DxtAccountStatistics.vue?vue&type=style&index=0&id=0c60ca0a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0c60ca0a"

export default script